<portal-sub-nav [force]="force" route="enterprise-ab-routing">
  <portal-menu-context [heading]="'menu.abRouting' | portalTranslate"></portal-menu-context>

  <!-- Routings -->
  <portal-sub-nav-item route="enterprise-ab-routing-routes">
    <ng-template portalTransclude>
      <span>{{ 'menu.abRouting.routes' | portalTranslate }}</span>
    </ng-template>
  </portal-sub-nav-item>

  <!-- Export Import -->
  <portal-sub-nav-item route="enterprise-ab-routing-export-import">
    <ng-template portalTransclude>
      <span>{{ 'menu.abRouting.export-import' | portalTranslate }}</span>
    </ng-template>
  </portal-sub-nav-item>
</portal-sub-nav>
